// extracted by mini-css-extract-plugin
export default {"searchForm":"bn_g4"};